
/* NIKA a11y: Flickity слага aria-hidden="true" на клетките извън екрана, а
   вътре има линкове/бутони → Lighthouse "ARIA hidden element must not
   contain focusable elements". Синхронизираме tabindex=-1 (без inert, за да
   остане кликаема надничащата карта). */
/* NIKA a11y: Flickity вкарва .flickity-viewport/.flickity-slider div-ове
   директно в <ul role="list"> → "roles must contain particular children".
   След init тракът става ARIA carousel (region + slides), не списък. */
function nikaCarouselRoles(track) {
  /* role=group е позволена за <ul> (region не е); li → none, съдържанието
     (линкове/бутони) остава достъпно */
  track.setAttribute('role', 'group');
  track.setAttribute('aria-roledescription', 'carousel');
  track.querySelectorAll(':scope .flickity-slider > *').forEach((li) => {
    li.setAttribute('role', 'none');
    li.removeAttribute('aria-roledescription');
    li.removeAttribute('aria-label');
  });
}

function nikaListRoles(track) {
  track.setAttribute('role', 'list');
  track.removeAttribute('aria-roledescription');
  track.querySelectorAll(':scope > li, :scope .flickity-slider > li').forEach((li) => {
    li.removeAttribute('role'); li.removeAttribute('aria-roledescription'); li.removeAttribute('aria-label');
  });
}

function nikaSyncHiddenFocus(track) {
  const sync = () => {
    track.querySelectorAll('[aria-hidden="true"] a, [aria-hidden="true"] button, [aria-hidden="true"] input, [aria-hidden="true"] select').forEach((el) => {
      if (el.getAttribute('tabindex') !== '-1') { el.dataset.nikaTab = el.getAttribute('tabindex') || ''; el.setAttribute('tabindex', '-1'); }
    });
    track.querySelectorAll('[data-nika-tab]').forEach((el) => {
      if (!el.closest('[aria-hidden="true"]')) {
        if (el.dataset.nikaTab) el.setAttribute('tabindex', el.dataset.nikaTab); else el.removeAttribute('tabindex');
        delete el.dataset.nikaTab;
      }
    });
  };
  new MutationObserver(sync).observe(track, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
  sync();
}
/**
 * NIKA: "Категории във фокуса" — динамични тренд категории от Algolia
 * Recommend (trending-facets върху фасета collections).
 * - Само подкатегории от ниво 2 на менюто (nikaMenuTree) — родителските
 *   нива, вендор колекциите и служебните отпадат.
 * - Кеш 6 часа в localStorage (както класационните слайдери).
 * - При грешка/липса на данни статичните сървърни плочки остават.
 */
(function () {
  var el = document.querySelector('[data-nika-trending-cats]');
  var CFG = window.NIKA_ALGOLIA;
  if (!el || !CFG) return;

  var TTL = 21600000; /* 6 часа */
  var GENERIC = {
    all: 1, 'stroitelni-produkti': 1, 'dom-i-gradina': 1, 'profesionalno-obzavezhdane': 1,
    'stalbi-i-skeleta': 1, promocii: 1, 'nika-nay-kupuvani': 1,
    'orderly-emails-recommended-products': 1, italy: 1, germany: 1, usa: 1, france: 1,
    'out-of-stock': 1,
  };

  function cacheGet(k) {
    try {
      var r = JSON.parse(localStorage.getItem(k) || 'null');
      return r && Date.now() - r.t < TTL ? r.v : null;
    } catch (e) { return null; }
  }
  function cacheSet(k, v) {
    try { localStorage.setItem(k, JSON.stringify({ t: Date.now(), v: v })); } catch (e) { /* ignore */ }
  }

  /* ниво 2 = подкатегориите от главното меню */
  /* строго ниво 2: подкатегория в менюто, която САМА не е родител
     (изключва "Алуминиеви стълби" и другите широки категории) */
  var menuTree = (function () {
    var s = document.getElementById('nikaMenuTree');
    var subs = {};
    var parents = {};
    if (s) {
      (s.textContent || '').split('~').forEach(function (row) {
        var p = row.split('|');
        if (p[0] && p[1]) {
          parents[p[0].trim()] = 1;
          p[1].split(',').forEach(function (x) { x = x.trim(); if (x) subs[x] = 1; });
        }
      });
    }
    return { subs: subs, parents: parents };
  })();
  if (!Object.keys(menuTree.subs).length) return;

  function trending() {
    var c = cacheGet('nika-trend-cats');
    if (c) return Promise.resolve(c);
    return fetch('https://' + CFG.appId + '-dsn.algolia.net/1/indexes/*/recommendations', {
      method: 'POST',
      headers: {
        'X-Algolia-Application-Id': CFG.appId,
        'X-Algolia-API-Key': CFG.searchKey,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ requests: [{ indexName: CFG.index, model: 'trending-facets', facetName: 'collections', threshold: 0, maxRecommendations: 40 }] }),
    }).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (d) {
      var vals = ((d.results && d.results[0] && d.results[0].hits) || []).map(function (h) { return h.facetValue; }).filter(Boolean);
      if (vals.length) cacheSet('nika-trend-cats', vals);
      return vals;
    });
  }

  function colInfo() {
    var c = cacheGet('nika-trend-colinfo');
    if (c) return Promise.resolve(c);
    var list = [];
    function page(p) {
      if (p > 2) return Promise.resolve(list);
      return fetch('/collections.json?limit=250&page=' + p).then(function (r) {
        if (!r.ok) return list;
        return r.json().then(function (d) {
          var cc = d.collections || [];
          cc.forEach(function (c) { list.push({ h: c.handle, t: c.title, img: (c.image && c.image.src) || '' }); });
          return cc.length === 250 ? page(p + 1) : list;
        });
      });
    }
    return page(1).then(function (l) { if (l.length) cacheSet('nika-trend-colinfo', l); return l; });
  }

  /* NIKA: нашите тренд категории (метафийлд, вграден JSON) — без Algolia и
     без /collections.json; под 4 годни → старият Algolia поток */
  function embedded() {
    var el = document.querySelector('script[data-nika-trend-cols]');
    if (!el) return null;
    try { var arr = JSON.parse(el.textContent || '[]'); return arr.length ? arr : null; } catch (e) { return null; }
  }
  var own = embedded();
  var source = own
    ? Promise.resolve([own.map(function (c) { return c.h; }), own])
    : Promise.all([trending(), colInfo()]);

  function run(res, allowFallback) {
    var vals = res[0];
    var by = {};
    res[1].forEach(function (c) { by[c.h] = c; });
    var grid = el.querySelector('[data-nika-trend-grid]');
    if (!grid) return;
    var track = grid.querySelector('.nika-trend-grid__track');
    /* всички годни кандидати от кеша... */
    var eligible = [];
    for (var i = 0; i < vals.length; i++) {
      var v = vals[i];
      if (GENERIC[v] || !menuTree.subs[v] || menuTree.parents[v]) continue;
      var c = by[v];
      if (!c || !c.img) continue; /* без снимка клетката би била празна */
      if (eligible.some(function (p) { return p.h === c.h; })) continue;
      eligible.push(c);
    }
    if (eligible.length < 4) {
      /* недостиг от нашите данни → пробвай Algolia; иначе секцията остава скрита */
      if (allowFallback) return Promise.all([trending(), colInfo()]).then(function (r) { return run(r, false); });
      return;
    }
    /* ...ротация с 4 при всяко зареждане: първите 4 видими са ГАРАНТИРАНО
       различни от предишния път (не случайно разбъркване, което повтаря) */
    var rot = 0;
    try { rot = (parseInt(localStorage.getItem('nika-trend-rot') || '0', 10) + 4) % eligible.length; } catch (e) { /* ignore */ }
    try { localStorage.setItem('nika-trend-rot', String(rot)); } catch (e) { /* ignore */ }
    eligible = eligible.slice(rot).concat(eligible.slice(0, rot));
    track.innerHTML = eligible.map(function (c) {
      var src = c.img + (c.img.indexOf('?') > -1 ? '&' : '?') + 'width=600';
      return '<a class="nika-trend-grid__card" href="/collections/' + c.h + '">' +
        '<span class="nika-trend-grid__imgwrap"><img src="' + src + '" alt="" loading="lazy" width="400" height="400"></span>' +
        '<span class="nika-trend-grid__title"></span></a>';
    }).join('');
    /* заглавията като текст (без HTML инжекция) */
    var titles = grid.querySelectorAll('.nika-trend-grid__title');
    eligible.forEach(function (c, i) { if (titles[i]) titles[i].textContent = c.t; });
    /* данните са готови — покажи секцията */
    el.hidden = false;
    /* Flickity като nika-recs (зареден е от слайдерите на страницата) */
    var tries = 0;
    (function initFlickity() {
      if (!window.Flickity) { if (tries++ < 50) setTimeout(initFlickity, 100); return; }
      if (track.classList.contains('flickity-enabled')) return;
      var flkty = new window.Flickity(track, {
        cellAlign: 'left',
        contain: true,
        freeScroll: true,
        pageDots: false,
        prevNextButtons: true,
        groupCells: true,
        watchCSS: true,
      });
      nikaSyncHiddenFocus(track);
      if (track.classList.contains('flickity-enabled')) nikaCarouselRoles(track);
      flkty.on('activate', function () { nikaCarouselRoles(track); });
      flkty.on('deactivate', function () { nikaListRoles(track); });
    })();
  }

  source.then(function (res) { return run(res, !!own); }).catch(function () { /* статичните остават */ });
})();
